import { MapPin, CalendarClock } from "lucide-react";
import { ContactForm } from "../components/site/ContactForm";
import { Reveal, SectionHeading } from "../components/site/Reveal";
import { useCalendly } from "../components/site/CalendlyModal";
import { SITE_CONFIG } from "../config/site";

export default function ContactoPage() {
  const { openCalendly } = useCalendly();
  return (
    <div data-testid="contacto-page">
      <section className="pt-44 pb-28">
        <div className="mx-auto max-w-7xl px-6 grid gap-16 lg:grid-cols-[1fr_1.2fr]">
          <div>
            <SectionHeading
              eyebrow="Contacto"
              title={<>Empecemos por <span className="text-gradient">una conversación.</span></>}
              copy="Cuéntanos qué proceso, aplicación o reto tecnológico quieres mejorar. Respondemos con una propuesta clara, no con un discurso."
              testId="contacto-heading"
            />
            <Reveal delay={0.2}>
              <div className="mt-10 space-y-4">
                <p className="flex items-center gap-3 text-sm text-[var(--muted)]">
                  <MapPin size={16} className="text-[var(--green)]" /> {SITE_CONFIG.location}
                </p>
                <p className="flex items-center gap-3 text-sm text-[var(--muted)]">
                  <span className="mono text-[11px] tracking-[0.2em] uppercase text-[var(--green)]">Email</span>
                  <a href={`mailto:${SITE_CONFIG.email}`} className="hover:text-[var(--ink)] transition-colors" data-testid="contacto-email">{SITE_CONFIG.email}</a>
                </p>
                <p className="flex items-center gap-3 text-sm text-[var(--muted)]">
                  <span className="mono text-[11px] tracking-[0.2em] uppercase text-[var(--green)]">Móvil</span>
                  <a href={`tel:${SITE_CONFIG.phone.replace(/[\s-]/g, "")}`} className="hover:text-[var(--ink)] transition-colors" data-testid="contacto-telefono">{SITE_CONFIG.phone}</a>
                </p>
                <button
                  onClick={openCalendly}
                  className="btn-glow inline-flex items-center gap-2 rounded-full bg-[var(--surface2)] px-6 py-3 text-sm font-semibold"
                  data-testid="contacto-cta-agendar"
                  data-cursor="cta"
                >
                  <CalendarClock size={16} className="text-[var(--green)]" /> Agendar una reunión
                </button>
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <ContactForm />
          </Reveal>
        </div>
      </section>
    </div>
  );
}
